import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';

import 'bootstrap/dist/css/bootstrap.min.css';


// ---------------------------------------------------------------------------
function ModalPage(props) {

  // --------------------------
  return (
    <Modal show={props.show} onHide={props.onHide}  size="xl" aria-labelledby={props.windowTitle} className={props.className}>
      <Modal.Header style={{backgroundColor:'#226C7A'}} closeButton>
        <Modal.Title style={{color:'white'}}>
            {props.windowTitle}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {props.body_component}
      </Modal.Body>

      {props.footer_component &&
        <Modal.Footer>
          {props.footer_component}
        </Modal.Footer>
      }
    </Modal>
  );
}

// Do not use title. "Title" is a regular attribute used to display tooltip help
ModalPage.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  windowTitle: PropTypes.string.isRequired,
  body_component: PropTypes.element.isRequired,
  footer_component: PropTypes.element,
}

export default ModalPage;
